import React, {RefObject, useEffect} from 'react';
import Moveable from "react-moveable";
import {useTemplate} from "../../../context/TemplateContext";


interface ImageDragAndResizeProps {
    templateContainerRef: RefObject<HTMLDivElement>;
}

const ImageDragAndResize: React.FC<ImageDragAndResizeProps> = ({
                                                                   templateContainerRef,
                                                               }) => {

    const {imageTransforms, setImageTransforms, selectedTransformedImage, setSelectedTransformedImage} = useTemplate();

    useEffect(() => {
        if (!selectedTransformedImage || !imageTransforms?.[selectedTransformedImage]) return;

        const {width, height, top, left, reset} = imageTransforms?.[selectedTransformedImage]
        const target = templateContainerRef.current?.querySelector(`[data-name="${selectedTransformedImage}"]`) as HTMLElement

        // Apply inline styles
        target.style.width = `${width}px`;
        target.style.height = `${height}px`;
        // Apply transform directly to the DOM element
        target.style.left = `${left}px`;
        target.style.top = `${top}px`;

        if (reset) {
            setSelectedTransformedImage(undefined)
        }

    }, [imageTransforms])

    return (
        <>
            {selectedTransformedImage && (
                <Moveable
                    // The "target" is the actual DOM element with data-name = selectedImage
                    target={
                        templateContainerRef.current?.querySelector(`[data-name="${selectedTransformedImage}"]`) as HTMLElement
                    }
                    draggable={true}
                    resizable={true}
                    pinchable={true}
                    keepRatio={true} // keep aspect ratio
                    throttleResize={0}
                    onDrag={({target, left, top}) => {
                        setImageTransforms((prev) => ({
                            ...prev,
                            [selectedTransformedImage]: {
                                ...prev[selectedTransformedImage],
                                left,
                                top,
                                transformed: true,
                                reset: undefined
                            },
                        }));
                    }}
                    onResize={({target, width, height, drag}) => {
                        const {left, top} = drag;
                        setImageTransforms((prev) => ({
                            ...prev,
                            [selectedTransformedImage]: {
                                ...prev[selectedTransformedImage],
                                left,
                                top,
                                width,
                                height,
                                transformed: true,
                                reset: undefined
                            },
                        }));

                        // keep transform only on use effect causes glitch while resizing

                        // Apply inline styles
                        target.style.width = `${width}px`;
                        target.style.height = `${height}px`;
                        // Apply transform directly to the DOM element
                        target.style.left = `${left}px`;
                        target.style.top = `${top}px`;

                    }}
                />
            )}
        </>
    );
};


export default ImageDragAndResize;
